import { Route } from '@angular/router';
import {
  adminGuard,
  caseManagerGuard,
  chatGuard,
  dataAccessAuthGuard,
  teleconsultationGuard,
  hrGuard,
  laboratoryGuard,
  patientsGuard,
  homeRedirectGuard,
  supportChatGuard,
} from '@nutrix/data-access-guard-auth';
import { FeatLayoutComponent } from '@nutrix/feat-layout';

export const appRoutes: Route[] = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('@nutrix/feat-login').then((m) => m.FeatLoginComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('@nutrix/ui-reset-password').then((m) => m.UiResetPasswordComponent),
  },
  {
    path: 'email-verification',
    loadChildren: () => import('@nutrix/feat-email-verification').then((m) => m.featEmailVerificationRoutes),
  },
  {
    path: 'profile-create',
    loadChildren: () => import('@nutrix/feat-user-profile').then((m) => m.featUserProfileRoutes),
  },
  { path: 'membership/oauth2', loadComponent: () => import('@nutrix/feat-oauth').then((m) => m.FeatOauthComponent) },
  {
    path: 'home',
    component: FeatLayoutComponent,
    canActivate: [dataAccessAuthGuard],
    canActivateChild: [dataAccessAuthGuard],
    children: [
      {
        path: '',
        canActivate: [homeRedirectGuard],
        children: [],
      },
      {
        path: 'users',
        canActivate: [adminGuard],
        loadComponent: () => import('@nutrix/feat-admin').then((c) => c.FeatAdminComponent),
      },
      {
        path: 'agenda',
        canActivate: [teleconsultationGuard],
        loadComponent: () => import('@nutrix/feat-agenda').then((c) => c.FeatAgendaComponent),
      },
      {
        path: 'patients',
        canActivate: [patientsGuard],
        loadChildren: () => import('@nutrix/feat-patients').then((c) => c.patientsRoutes),
      },
      {
        path: 'chats',
        canActivate: [chatGuard],
        loadComponent: () => import('@nutrix/feat-chat').then((m) => m.FeatChatComponent),
      },
      {
        path: 'support',
        canActivate: [supportChatGuard],
        loadComponent: () => import('@nutrix/feat-support-chat').then((m) => m.FeatSupportChatComponent),
      },
      {
        path: 'case-manager',
        canActivate: [caseManagerGuard],
        loadChildren: () => import('@nutrix/feat-case-manager').then((m) => m.featCaseManagerRoutes),
      },
      {
        path: 'profile',
        loadChildren: () => import('@nutrix/feat-user-profile').then((m) => m.featUserProfileRoutes),
      },
      {
        path: 'hr',
        canActivate: [hrGuard],
        loadChildren: () => import('@nutrix/feat-hr').then((c) => c.featHrRoutes),
      },
      {
        path: 'laboratory',
        canActivate: [laboratoryGuard],
        loadComponent: () => import('@nutrix/feat-laboratory').then((c) => c.FeatLaboratoryComponent),
      },
      {
        path: 'lab-availability',
        canActivate: [laboratoryGuard],
        loadComponent: () => import('@nutrix/feat-laboratory').then((c) => c.LabAvailabilityComponent),
      },
      {
        path: '**',
        loadChildren: () => import('@nutrix/feat-page-not-found').then((c) => c.featPageNotFoundRoutes),
      },
    ],
  },
  {
    path: 'profile',
    canActivate: [dataAccessAuthGuard],
    loadChildren: () => import('@nutrix/feat-user-profile').then((m) => m.featUserProfileRoutes),
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
    pathMatch: 'full',
  },
  {
    path: 'page-not-found',
    loadChildren: () => import('@nutrix/feat-page-not-found').then((c) => c.featPageNotFoundRoutes),
  },
];
